export function isMobileDevice() {
    try {
        // eslint-disable-next-line compat/compat
        return 'ontouchstart' in window && window.navigator.maxTouchPoints > 0;
    }
    catch (e) {
        return false;
    }
}
